import React from "react";
import { string, objectOf, number, oneOfType, shape } from "prop-types";
import classNames from "classnames";
import * as styles from "./SvgIcons.module.scss";

const SvgIcons = ({ className, style, icon }) => (
	<i
		className={classNames(styles.icon, className)}
		style={style}
		// eslint-disable-next-line react/no-danger
		dangerouslySetInnerHTML={{
			__html: icon && icon.svg && icon.svg.content && icon.svg.content,
		}}
	/>
);

SvgIcons.propTypes = {
	icon: shape({
		svg: shape({
			content: string.isRequired,
		}),
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};
SvgIcons.defaultProps = {
	className: "",
	style: {},
};

export default SvgIcons;
export { SvgIcons };
